import Common from './pages/common.js';
import Top from './pages/top.js';
import Questionary from './pages/questionary.js';
class App {
	constructor() {
		this.routes();
		// console.log('App');
	}

	routes() {
		new Common();
		new Top();
		new Questionary();
	}
}

window.App = new App();
